import classNames from 'classnames/bind';
import styles from './Teacher.module.css';

import {
  useGetSignupTeacherFormQuery,
  useSubmitSignUpTeacherMutation,
} from '../../../../services/api';

import SignUpForm from '../SignUpForm';

export default function Teacher() {
  const cx = classNames.bind(styles);
  const { data, isLoading } = useGetSignupTeacherFormQuery();
  const [submit] = useSubmitSignUpTeacherMutation();

  if (isLoading || !data) return null;

  return (
    <>
      <SignUpForm form={data} submit={submit} alias={data.alias} />
    </>
  );
}
